/**
 * Gift Design Choice Updater
 * Updates the _design_choice property on gift items
 */
(() => {
  'use strict';

  // Use global debug flag from theme settings
  const log = (...args) => window.PITCHPRINT_DEBUG && console.log('[GiftDesignChoice]', ...args);

  log('Script loaded');

  let isUpdating = false;

  /**
   * Update gift design choice property
   */
  const updateDesignChoice = async (itemIndex, designChoice) => {
    if (isUpdating) {
      log('Update already in progress, skipping');
      return;
    }

    isUpdating = true;

    try {
      log('Updating design choice to:', designChoice);

      // Get current cart to find the item
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const item = cart.items[itemIndex - 1];

      if (!item || !item.properties || !item.properties._auto_gift) {
        console.error('[GiftDesignChoice] Item not found or not an auto-gift');
        isUpdating = false;
        return;
      }

      // Update the properties (use visible property name for checkout)
      const updatedProperties = {
        ...item.properties,
        'Design Choice': designChoice
      };

      // Update the line item properties
      const updateResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: itemIndex,
          quantity: item.quantity,
          properties: updatedProperties
        })
      });

      if (!updateResponse.ok) {
        throw new Error(`Failed to update design choice: ${updateResponse.status}`);
      }

      log('✅ Design choice updated successfully');

      // Emit cart updated event
      document.dispatchEvent(new CustomEvent('cart:updated'));

    } catch (error) {
      console.error('[GiftDesignChoice] Error updating design choice:', error);
      isUpdating = false;
    } finally {
      isUpdating = false;
    }
  };

  /**
   * Initialize design choice selectors
   */
  const initializeSelectors = () => {
    const selectors = document.querySelectorAll('.gift-design-select');

    if (selectors.length === 0) {
      log('No gift design selects found');
      return;
    }

    selectors.forEach(select => {
      // Remove old listener if exists
      const newSelect = select.cloneNode(true);
      select.parentNode.replaceChild(newSelect, select);

      // Add new listener
      newSelect.addEventListener('change', (e) => {
        const itemIndex = parseInt(e.target.closest('.gift-design-choice').dataset.giftItemIndex);
        const designChoice = e.target.value;
        updateDesignChoice(itemIndex, designChoice);
      });
    });

    log('Initialized', selectors.length, 'selector(s)');
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSelectors);
  } else {
    initializeSelectors();
  }

  // Re-initialize when cart drawer opens
  document.addEventListener('cartdrawer:opened', () => {
    log('Cart drawer opened, initializing');
    setTimeout(initializeSelectors, 300);
  });

  log('Event listeners registered');

})();
